import React from 'react'
import NumberFormat, { NumberFormatProps } from 'react-number-format'

interface IPriceFormatProps {
  customInput?: React.ComponentType
}

const PriceFormat = ({
  customInput,
  decimalSeparator = ',',
  decimalScale = 2,
  ...rest
}: IPriceFormatProps & NumberFormatProps) => {
  return (
    <NumberFormat
      customInput={customInput}
      thousandSeparator={' '}
      decimalSeparator={decimalSeparator}
      decimalScale={decimalScale}
      fixedDecimalScale={true}
      allowLeadingZeros={false}
      {...rest}
    />
  )
}

export default PriceFormat
